import { back2top, navbarScroll, loadTooptip, modeWatcher } from '../components';

export function basic() {
  navbarScroll();
  modeWatcher();
  back2top();
  loadTooptip();
}
